module.exports = __webpack_public_path__ + "static/media/success-circle.c942cc5c.svg";